import {Slot, Switch, Text, Trail, Typography} from '@yandex-delivery/blocks'

import {MultiSwitchOption} from '../../types'
import {classes} from './MultiSwitchRequirementItem.classes'

type Props = {
  name: string
  isChecked: boolean
  option: MultiSwitchOption
  onChange: () => void
}

export function MultiSwitchRequirementItem({name, isChecked, option, onChange}: Props) {
  return (
    <Slot size="l">
      <Text className={classes.body}>
        <Typography thickness="regular" variant="body2">
          {option.name}
        </Typography>
        {option.description && (
          <Typography color="minor" variant="caption1">
            {option.description}
          </Typography>
        )}
      </Text>
      <Trail>
        <Switch name={name} on={isChecked} onChange={onChange} size="m" />
      </Trail>
    </Slot>
  )
}
